const setSessionStorage = (key: string, value: string) => {
	sessionStorage.setItem(key, value);
};

const getSessionStorage = (key: string) => {
	return sessionStorage.getItem(key);
};

export { getSessionStorage, setSessionStorage };
